import { render } from "./TheError404.vue?vue&type=template&id=b0f0a13c"
import script from "./TheError404.vue?vue&type=script&lang=js"
export * from "./TheError404.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__